export const VALIDATE_CART_CONTENT_MUTATION = `
mutation CartMutation {
   validateCart {
      data {

      discounts {
        discountType
        isPercentDiscount
        maxDiscount
        moneyValue
        percentValue
      }
      pricesSummary {
          vat
          priceItemSummary
          pricePayment
          priceDelivery
          priceProductsSummary
          discountWithoutDelivery
      }
      benefits {
        loyalty {
          loyalties {
              percentageValue
              localizedNavigationName
              discountType
              loyaltyType
              value
              state
              tags
              orderPriceActivationThresholdWithVat
              minimalOrderPriceThresholdWithVat
              expirationDate
              validUntil
          }
        }
        vouchers {
          code
          value
          isDeliveryVoucher
        }
      }
    }
    messages
  }
}
`;
